import { render, staticRenderFns } from "./TipsOpenHours.vue?vue&type=template&id=1f3bfc02"
import script from "./TipsOpenHours.vue?vue&type=script&lang=js"
export * from "./TipsOpenHours.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports